import { css } from '@emotion/react';

import { typography } from '@core/Typography2';
import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('paginationItem', [
  'selected',
  'default',
]);

const getPaginationItemCss = css`
  background: transparent;
  color: var(--cds-color-interactive-secondary-inactive);
  ${typography.bodySecondary};

  &:hover {
    background: transparent;
    color: var(--cds-color-interactive-secondary-hover);
    text-decoration: none;

    /* the :not(div) is a workaround for the MoreActionsIcon variant of pagination item, which is not interactive */
    &:not(div)::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: var(--cds-spacing-50);
      width: var(--cds-spacing-300);
      margin: 0 auto;
      background-color: var(--cds-color-neutral-stroke-primary-weak);
      border-radius: var(--cds-border-radius-25) var(--cds-border-radius-25) 0 0;
    }
  }

  &:focus-visible {
    background: transparent;
    color: var(--cds-color-interactive-secondary-hover);
    text-decoration: none;
  }

  &.${classes.selected} {
    color: var(--cds-color-interactive-secondary);
    background: transparent;
    box-shadow: none;

    ${typography.actionSecondary};
    &:not(div)::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: var(--cds-spacing-50);
      width: var(--cds-spacing-300);
      margin: 0 auto;
      background-color: var(--cds-color-neutral-primary);
      border-radius: var(--cds-border-radius-25) var(--cds-border-radius-25) 0 0;
    }
  }

  &.${classes.default} {
    height: 36px;
    width: 36px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export default getPaginationItemCss;
